// eslint-disable-next-line @typescript-eslint/no-explicit-any
const content: { [key: string]: any } = {
  title: {
    pageTitle: "CVR Compliance",
    pageDescription:
      "The CVR Compliance Action Report includes downline IBOs who are not compliant with the customer volume rule of at least 50 PV of Verified Customer Sales (including both online and receipts). When compliant, an IBO may be eligible for additional bonuses.",
    reportCount: "IBOs Who are not CVR Compliant",
  },
  info: {
    ariaLabel: "CVR Compliance information",
  },
  export: {
    button: "Export",
    title: "Export Report",
    description:
      "This Report will include a list of downline IBOs who are not compliant with the customer volume rule.",
    exportTypeLabel: "CVR Compliance",
  },
  table: {
    columns: {
      aboName: "ABO Name / Number",
      vcsPV: "VCS PV",
      nonVCSPV: "Non VCS PV",
      personalPV: "PPV",
      bonusPercent: "Bonus %",
      annualPPV: "Annual PPV",
      watchlist: "Watchlist",
    },
  },
  losTreeView: "LOS Tree View",
} as const;

export default content;
